import {
  getSubUserPolicies,
  updatePoliciesBySubUserId,
  uploadBulkSubUserPolicies,
  getSubUserActivationList,
  updateSubUserRegistrationActivation,
} from '../../utils/api';
import { FAILED, LOADING, SUCCESS, CLEAR_MESSAGE, RESET } from './constants';

export const fetchList = (params = {}) => {
  return async (dispatch, getState) => {
    const { totalPage } = getState().subMerchantActivation.dataSubMerchantActivationList.meta;
    let dataList = [];
    if (params.page > 1 && params.page > totalPage) {
      return;
    }
    const key = 'SubMerchantActivationList';
    try {
      if (params?.page !== 1 && params?.page !== '1') {
        // dispatch(successAction({ data : [] }, key));
        dataList = getState().subMerchantActivation.dataSubMerchantActivationList.data;
      }
      dispatch(loadingAction(false, 'SubMerchantActivationSubmit'));
      dispatch(loadingAction(true, key));
      const requestParams = {
        ...params,
        size: 100,
      };

      let { data, meta } = await getSubUserActivationList(requestParams);
      dispatch(successAction({ data: [...dataList, ...data], meta }, key));
      dispatch(successAction(false, 'SubMerchantActivationSubmit'));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
};

export function setSubMerchantActivationFilter(filter) {
  return async (dispatch) => {
    dispatch(successAction(filter, 'Filter'));
  };
}

export const submitActivation = (data = {}) => {
  return async (dispatch) => {
    const key = 'SubMerchantActivationSubmit';
    dispatch(loadingAction(true, key));
    try {
      data = {
        regional: data.region,
        provinceId: data.provinceId,
        cityId: data.cityId,
        districtId: data.districtId,
        villageId: data.villageId,
        isRegisterSubPangkalan: +data.isRegisterSubPangkalan,
      };
      await updateSubUserRegistrationActivation(data);
      dispatch(successAction(true, key));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
};

export const editStatusBySubUserId = (data = {}) => {
  return async (dispatch) => {
    const key = 'EditStatusBySubUserId';
    dispatch(loadingAction(true, key));
    try {
      data = {
        userId: data.userId,
        isRegisterSubPangkalan: +data.isRegisterSubPangkalan,
      };
      await updatePoliciesBySubUserId(data);
      dispatch(successAction(true, key));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
};

export const submitUploadSubMerchantActivation = (file = {}, callback = () => {}) => {
  return async (dispatch) => {
    const key = 'UploadSubMerchantActivation';
    dispatch(loadingAction(true, key));
    callback();
    try {
      const { data } = await uploadBulkSubUserPolicies(file.file);
      dispatch(successAction(data, key));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
};

export const searchSubUserByRegistrationId = (registrationId = '') => {
  return async (dispatch) => {
    const key = 'SubMerchantActivationSearch';
    const keyEditStatus = 'EditStatusBySubUserId';
    dispatch(successAction(false, keyEditStatus));
    dispatch(loadingAction(true, key));
    try {
      const { data } = await getSubUserPolicies(registrationId);
      dispatch(successAction(data, key));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
};

export function failedAction(message, key) {
  return { type: FAILED, message, key };
}

export function loadingAction(isLoading, key) {
  return { type: LOADING, isLoading, key };
}

export function successAction(data, key) {
  return { type: SUCCESS, data, key };
}

export function clearMessage(key) {
  return async (dispatch) => {
    dispatch({ key, type: CLEAR_MESSAGE });
  };
}

export const resetState = (key) => {
  return async (dispatch) => {
    dispatch({ key, type: RESET });
  };
};
